// File: ShapesTablePanel.js

import React, { useMemo, useState } from "react";
import Grid from "@mui/material/Grid2";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Checkbox from "@mui/material/Checkbox";
import MaterialUiDataGridPremium from "../../../../components/Tables/DataGridPremium/MaterialUiDataGridPremium";

export default function ShapesTablePanel({ shapes = [] }) {
  const [editableShapeIds, setEditableShapeIds] = useState([]);

  const handleCheckboxChange = (id) => {
    setEditableShapeIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1
    },
    {
      field: "type",
      headerName: "Type",
      flex: 1
    },
    {
      field: "pointCount",
      headerName: "# Points",
      valueGetter: (params) => params?.row?.coordinates?.length || 0,
      flex: 0.7
    },
    {
      field: "center",
      headerName: "Center",
      valueGetter: (params) => {
        const coords = params?.row?.coordinates;
        if (!coords?.length) return "";
        const latSum = coords.reduce((sum, pt) => sum + pt.lat, 0);
        const lngSum = coords.reduce((sum, pt) => sum + pt.lng, 0);
        return `${(latSum / coords.length).toFixed(5)}, ${(lngSum / coords.length).toFixed(5)}`;
      },
      flex: 1.5
    },
    {
      field: "editable",
      headerName: "Editable",
      renderCell: (params) => (
        <Checkbox
          checked={editableShapeIds.includes(params?.row?.id)}
          onChange={() => handleCheckboxChange(params?.row?.id)}
        />
      ),
      sortable: false,
      flex: 0.8
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      renderCell: () => (
        <>
          <IconButton size="small">
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" color="error">
            <DeleteIcon fontSize="small" />
          </IconButton>
        </>
      ),
      flex: 1
    }
  ];

  const rows = useMemo(() => shapes, [shapes]);

  return (
    <>
        <MaterialUiDataGridPremium
          rows={rows}
          columns={columns}
          getRowId={(row) => row.id}
          autoHeight
          checkboxSelection={false}
          hideFooter={false}
          pagination={true}
          pageSize={10}
          showGridToolBar={true}
        />
        </>
  );
}
